import { useMemo } from 'react';
// routes
import { paths } from 'src/routes/paths';
// components
import SvgColor from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  // OR
  // <Iconify icon="fluent:mail-24-filled" />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

const ICONS = {
  notification: icon('ic_notification'),
  gift: icon('ic_gift'),
  wallet: icon('ic_wallet'),
  job: icon('ic_job'),
  blog: icon('ic_blog'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  tour: icon('ic_tour'),
  order: icon('ic_order'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  product: icon('ic_product'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
};

// ----------------------------------------------------------------------

export function useNavData() {
  const data = useMemo(
    () => [
      // OVERVIEW
      // ----------------------------------------------------------------------
      {
        // subheader: 'overview',
        items: [
          // { title: 'Dashboard', path: paths.dashboard.root, icon: ICONS.dashboard, type: "link" },
          { title: 'Account', path: paths.dashboard.account, icon: ICONS.user, type: "button", text: "account" },
          { title: 'Cashier', path: paths.dashboard.group.six, icon: ICONS.wallet, type: "button", text: "cashier" },
          { title: 'Rewards', path: paths.dashboard.root, icon: ICONS.gift, type: "button", text: "rewards" },
          { title: 'Notifications', path: paths.dashboard.two, icon: ICONS.notification, type: "button", text: "notifications" },
          {
            title: 'More',
            path: paths.dashboard.group.root,
            icon: ICONS.file,
            children: [
              { title: 'About Us', path: paths.dashboard.group.root, type: "button", text: "about us" },
              // { title: 'Payment Methods', path: paths.dashboard.group.five, type: "button", text: "payment method" },
              { title: 'Game Providers', path: paths.dashboard.group.six, type: "button", text: "game providers" },
            ],
          },
        ],
      },
    ],
    []
  );

  return data;
}

export function useLockNavData() {
  const data = useMemo(
    () => [
      {
        // subheader: 'Sign',
        items: [
          { title: 'Sign Up', path: paths.auth.register, type: "link", variant: "contained" },
          { title: 'Sign In', path: paths.auth.login, type: "link", variant: "text" }
        ]
      }
    ],
    []
  );

  return data;
}